export default __webpack_public_path__ + "static/media/mint-section.4a36f014.png";